import React from 'react'
import { Badge } from '@/components/common/Badge'
import { PageHeader } from '@/components/common/PageHeader'
import { SectionTitle } from '@/components/common/SectionTitle'
import { useCurrentUser } from '@/hooks/useCurrentUser'
import './prototype.css'

const connectionLabels = {
  loading: 'Cargando sesión',
  authenticated: 'Sesión Microsoft',
  profile_pending: 'Perfil pendiente',
  unauthorized: 'Sesión no autorizada',
  not_configured: 'API pendiente',
  error: 'Sesión con error',
} as const

export const Configuracion: React.FC = () => {
  const currentUser = useCurrentUser()
  const user = currentUser.data?.user
  const connectionLabel = connectionLabels[currentUser.status]

  return (
    <div className="prototypePage">
      <PageHeader
        title="Configuración"
        subtitle="Identidad Microsoft y estado de conexión reales."
        action={<Badge label="Vista de solo lectura" variant="info" />}
      />

      <section className="prototypeSection">
        <SectionTitle
          title="Contexto Microsoft"
          subtitle="Identidad y estado de conexión de la sesión actual."
        />
        <div className="prototypeSettingsTray">
          <div className="prototypeSettingRow">
            <span className="prototypeSettingRow__label">Nombre</span>
            <strong className="prototypeSettingRow__value">{user?.nombre ?? 'Sin sesión'}</strong>
          </div>
          <div className="prototypeSettingRow">
            <span className="prototypeSettingRow__label">Correo</span>
            <strong className="prototypeSettingRow__value">{user?.email ?? 'Sin correo disponible'}</strong>
          </div>
          <div className="prototypeSettingRow">
            <span className="prototypeSettingRow__label">Estado de conexión</span>
            <Badge label={connectionLabel} variant={currentUser.status === 'authenticated' ? 'success' : 'info'} size="sm" />
          </div>
        </div>
      </section>
    </div>
  )
}
